import { IButtonStyles } from "@fluentui/react";
import { ButtonStyleProps, ITheme } from "cayo.ui";
import { FormThemes } from "@cayo/shared/api/types/schema";

export const getButtonThemeStyles = (props: ButtonStyleProps): IButtonStyles => {
  return {
    root: props.normal as any,
    rootHovered: props.hover as any,
    rootPressed: props.pressed as any,
  };
};

export const getFormThemeColors = (formTheme?: FormThemes, cayoTheme?: ITheme["cayoTheme"]) => {
  const getButtonColors = (color?: string) => ({
    backgroundColor: color,
    borderColor: color,
  });

  switch (formTheme) {
    case FormThemes.Danger:
      return getButtonThemeStyles({
        normal: getButtonColors(cayoTheme?.brandColors.critical),
        // TODO: set colors to theme scheme and retrieve them from there
        hover: getButtonColors("#c40001"),
        pressed: getButtonColors("#ae0001"),
      });
    default:
      return {};
  }
};
